import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteNav } from '@/mocks/common';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50 border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-2xl font-bold text-primary-500 tracking-tight">
              BOB
            </span>
            <span className={`text-sm font-medium transition-colors ${scrolled || !isHome ? 'text-foreground-700' : 'text-white'}`}>
              体育
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {siteNav.main.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === item.href || (item.href !== '/' && location.pathname.startsWith(item.href))
                    ? 'bg-primary-500 text-white'
                    : scrolled || !isHome
                      ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#"
              className="px-5 py-2 rounded-lg text-sm font-medium text-primary-500 border border-primary-300 hover:bg-primary-50 transition-colors whitespace-nowrap"
            >
              登录
            </a>
            <a
              href="#"
              className="px-5 py-2 rounded-lg text-sm font-medium bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              注册
            </a>
          </div>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors ${
              scrolled || !isHome ? 'text-foreground-700' : 'text-white'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {siteNav.main.map((item) => (
              <Link
                key={item.href}
                to={item.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  location.pathname === item.href
                    ? 'bg-primary-500 text-white'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-3 pt-3 border-t border-background-200/70">
              <a href="#" className="flex-1 px-4 py-2.5 rounded-lg text-sm font-medium text-center text-primary-500 border border-primary-300 hover:bg-primary-50 transition-colors">
                登录
              </a>
              <a href="#" className="flex-1 px-4 py-2.5 rounded-lg text-sm font-medium text-center bg-primary-500 text-white hover:bg-primary-600 transition-colors">
                注册
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}